import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

/** Returns the Shopify Admin base URL (e.g. "https://admin.shopify.com/store/oncloudtech").
 *  Empty string when on mock/local. Reads from the cached health response. */
export function useShopifyAdminURL(): string {
  const { data } = useQuery({
    queryKey: ["health"],
    queryFn: api.health,
    staleTime: 60_000,
  });
  return data?.shopify_admin_url ?? "";
}

/** Direct link to a product in Shopify Admin, or null if not available. */
export function useShopifyProductURL(shopifyProductId: string | number | null | undefined): string | null {
  const base = useShopifyAdminURL();
  if (!base || !shopifyProductId) return null;
  return `${base}/products/${shopifyProductId}`;
}
